import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Store } from '@ngrx/store'
import * as lodash from 'lodash'
import { debounceTime, filter, startWith, tap } from 'rxjs/operators'
import { SignerInputBaseComponent, SignerOptionItem } from '../signer-input-base.component'
import { untilDestroy } from '@tokeet-frontend/tv3-platform'
import { GuestService } from '@tv3/store/guest/guest.service'
import { ContractSignerType } from '@tokeet-frontend/signature'
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete'

@Component({
  selector: 'app-signer-custom-input',
  templateUrl: './signer-custom-input.component.html',
  styleUrls: ['./signer-custom-input.component.scss'],
})
export class SignerCustomInputComponent extends SignerInputBaseComponent implements OnInit {
  @Input() label: string
  @Input() placeholder: string
  @Input() ctrl: FormControl
  @Input() bindLabel: 'email' | 'name'
  @Input() searchable = true

  @Output() selectItem = new EventEmitter<SignerOptionItem>()

  signerTypes = ContractSignerType

  selectedValue: string

  constructor(store: Store<any>, guestService: GuestService) {
    super(store, guestService)
  }

  ngOnInit(): void {
    super.init()
    this.ctrl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(300),
        filter(() => this.searchable),
        filter((value) => value !== this.selectedValue),
        tap((value) => this.search$.next(value)),
        untilDestroy(this)
      )
      .subscribe()
  }

  onSignerSelect({ option }: MatAutocompleteSelectedEvent) {
    this.selectItem.emit(option.value)
    this.selectedValue = lodash.get(option.value, this.bindLabel)
  }
}
